import { buildAiErrorDetails, safeFetch } from "./client";
import { throwIfAborted } from "./runLifecycle";

const RUN_POLL_INTERVAL_MS = 2000;
const RUN_POLL_MAX_ATTEMPTS = 60;

const createTerminalRunError = (language, status) => {
  const error = new Error(
    language === "English"
      ? `Assistant run ended with status: ${status}`
      : `انتهى تشغيل المساعد بالحالة: ${status}`
  );
  error.aiErrorCode = `assistant_run_${status}`;
  error.aiErrorStatus = null;
  return error;
};

const createTimeoutError = (language, attempts, status) => {
  const error = new Error(
    language === "English"
      ? "AI analysis is still processing and exceeded the local waiting window."
      : "ما زال التحليل الذكي قيد المعالجة وتجاوز مهلة الانتظار المحلية."
  );
  error.aiErrorCode = "assistant_processing_timeout";
  error.aiErrorStatus = 408;
  error.pollAttempts = attempts;
  error.runStatus = status;
  return error;
};

export const waitForRunCompletion = async (headers, language, run, threadId, signal) => {
  let status = run.status;
  let attempts = 0;
  let lastRunStatus = run;

  while (status !== "completed" && attempts < RUN_POLL_MAX_ATTEMPTS) {
    throwIfAborted(signal);
    await new Promise((resolve) => setTimeout(resolve, RUN_POLL_INTERVAL_MS));
    attempts += 1;
    throwIfAborted(signal);

    const runStatus = await safeFetch(
      `https://api.openai.com/v1/threads/${threadId}/runs/${run.id}`,
      { headers, signal },
      language
    );

    lastRunStatus = runStatus;
    status = runStatus.status;

    if (status === "failed") {
      if (runStatus.last_error) {
        const details = buildAiErrorDetails({
          code: runStatus.last_error.code,
          language,
          message: runStatus.last_error.message,
        });
        const error = new Error(details.message);
        error.aiErrorCode = details.code;
        error.aiErrorStatus = details.status;
        throw error;
      }

      throw new Error("Assistant run failed during execution");
    }

    if (["cancelled", "expired", "incomplete"].includes(status)) {
      throw createTerminalRunError(language, status);
    }
  }

  if (attempts >= RUN_POLL_MAX_ATTEMPTS && status !== "completed") {
    throw createTimeoutError(language, attempts, status);
  }

  throwIfAborted(signal);
  return { attempts, finalStatus: status, lastRunStatus };
};
